module.exports = __webpack_public_path__ + "static/img/conecte-sus.a693755.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/img/conecte-sus.svg
// module id = c/cq
// module chunks = 15